module.exports = __webpack_public_path__ + "img/IPP.05b53997.jpg";